import CarSpecsCompare from '../../editorial/car_specs_compare';
import AnalyticsHelper from '../../utils/analytics-helper';
export default class CompareModal {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.configurator--compare-modal');
        this.data = parent.data;
        this.car = parent.car;
        this.open = [...this.parent.el.querySelectorAll('.performance-compare-link')];
        this.close = this.el.querySelector('.modal-close');
        this.wrapper = this.el.querySelector('.compare-grade-wrapper');
        this.bind();
    }

    bind() {
        this.close.addEventListener('click', (e) => this.hide());
        this.el.addEventListener('click', (e) => {
            if (!e.target.closest('.modal-container')) {
                this.hide();
            }
        });
        this.open.forEach((o) => o.addEventListener('click', (e) => {
            e.preventDefault();
            AnalyticsHelper.push(o);
            this.show();
        }));
    }

    show() {
        this.el.showModal();

        if (!this.compare) {
            this.compare = new CarSpecsCompare(this.wrapper);
        }

        this.compare.carousel.selectModel(this.car.data()?.code);
        this.el.querySelector('.modal-close').focus({ preventScroll: true });
    }

    hide() {
        this.el.close();
    }
}
